import { render, staticRenderFns } from "./newProductSales.vue?vue&type=template&id=46cd6224&scoped=true&"
import script from "./newProductSales.vue?vue&type=script&lang=js&"
export * from "./newProductSales.vue?vue&type=script&lang=js&"
import style0 from "./newProductSales.vue?vue&type=style&index=0&id=46cd6224&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cd6224",
  null
  
)

export default component.exports